"use strict";

/*!
 * Скрипт виджета избранных страниц
 */
(function ($) {
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;
    this.favouriteService = {
      last: function last() {
        return $.ajax('/FavouritePage/GetLast', {
          cache: false,
          dataType: 'json',
          method: 'GET',
          traditional: true
        });
      },
      remove: function remove(id) {
        return $.ajax('/FavouritePage/Remove', {
          data: {
            favouritePageId: id
          },
          dataType: 'json',
          method: 'POST',
          traditional: true
        });
      },
      add: function add(pageName, pageUrl) {
        return $.ajax('/FavouritePage/Add', {
          data: {
            name: pageName,
            url: pageUrl
          },
          dataType: 'json',
          method: 'POST',
          traditional: true
        });
      }
    };
    this.options = {
      $el: null,
      $list: null,
      $label: null,
      $link_add: null,
      $link_add_pane: null,
      $link_add_name: null,
      $link_add_url: null,
      $link_add_btn: null,
      $link_add_cancel_btn: null
    };
    this.updating = false;
    this.updating_callback = null; // функция, которую надо запустить после загрузки

    this.items = []; //список страниц

    this.init = function () {
      me.options.$el = $('#favourite-widget');
      if (me.options.$el.length > 0) {
        me.options.$el.addClass('emptydata');
      }
      me.options.$list = me.options.$el.find('#favourite-widget__list');
      if (me.options.$list.length > 0) {
        me.addNoDataMessage();
      }
      me.options.$label = me.options.$el.find('#favourite-widget__label');
      me.options.$link_add = me.options.$el.find('#favourite-widget__add');
      me.options.$link_add_pane = me.options.$el.find('#favourite-add');
      me.options.$link_add_name = me.options.$el.find('#favourite-add__name');
      me.options.$link_add_url = me.options.$el.find('#favourite-add__url');
      me.options.$link_add_btn = me.options.$el.find('#favourite-add__btn');
      me.options.$link_add_cancel_btn = me.options.$el.find('#favourite-add__cancel_btn');
      me.options.$link_add_pane.hide();
      me.options.$el.on("mouseover", function () {
        $.b2b.MainMenuWidgets.open("#favourite-widget");
      }).on("mouseleave", function () {
        $.b2b.MainMenuWidgets.closeWidget();
      });
      me.options.$link_add.on('click', function (e) {
        e.preventDefault();
        var url = window.location.pathname + window.location.search;
        var exciting = me.getUrlExists(url);
        if (exciting != null) {
          $.b2b.toastNotificationService.showError("\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0443\u0436\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430. \u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435: \"".concat(exciting, "\"."));
          return;
        }
        me.options.$link_add_url.val(url);
        me.options.$link_add_pane.show();
      });
      me.options.$link_add_cancel_btn.on('click', function (e) {
        me.clearAddPane();
        me.hideAddPane();
      });
      me.options.$link_add_btn.on('click', function (e) {
        var name = me.options.$link_add_name.val();
        var url = me.options.$link_add_url.val();
        if (url != undefined && url != '' && name != undefined && name != '') {
          me.add(name, url);
        }
      });
    };
    this.getUrlExists = function (url) {
      for (var i = 0; i < me.items.length; i++) {
        if (me.items[i].Url == url) {
          return me.items[i].Name;
        }
      }
      return null;
    };
    this.addNoDataMessage = function () {
      me.options.$list.append($('<span class="notifications-nodata">Нет избранных страниц</span>'));
    };
    this.clearAddPane = function () {
      me.options.$link_add_url.val('');
      me.options.$link_add_name.val('');
    };
    this.showAddPane = function () {
      me.options.$link_add_pane.show();
    };
    this.hideAddPane = function () {
      me.options.$link_add_pane.hide();
    };
    this.add = function (name, url) {
      me.favouriteService.add(name, url).done(function (data) {
        me.hideAddPane();
        me.clearAddPane();
        me.update();
      }).fail(function (jqXHR, textStatus, errorThrown) {
        $.b2b.errors.showAjaxError(jqXHR);
      });
    };
    this.update = function (disableRefresh) {
      if ($(document).find("#favourite-widget").length > 0) {
        me.updating = true;
        me.favouriteService.last().done(function (data) {
          me.updating = false;
          if (data.Success) {
            me.items = data.Data;
            if (disableRefresh !== true) {
              me.refresh();
            }
            if (me.updating_callback) {
              me.updating_callback.call(me);
            }
            return;
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          me.updating = false;
          $.b2b.errors.showAjaxError(jqXHR);
        });
      }
    };
    this["delete"] = function (e) {
      var deleteId = $(e.currentTarget).attr('data-favourite-id');
      me.favouriteService.remove(deleteId).done(function (data) {
        for (var i = 0; i < me.items.length; i++) {
          if (me.items[i].Id == deleteId) {
            me.items.splice(i, 1);
            break;
          }
        }
        me.refresh();
      }).fail(function (jqXHR, textStatus, errorThrown) {
        $.b2b.errors.showAjaxError(jqXHR);
      });
    };
    this.refresh = function () {
      if (me.options.$el) {
        if (me.updating) {
          // еще идет загрузка с сервера
          me.updating_callback = function () {
            me.refresh();
          };
          return;
        }
        var $ul = null;
        me.options.$el.removeClass('emptydata');
        if (me.items.length > 0) {
          // собираем список
          $ul = $('<ul/>');
          for (var i = 0; i < me.items.length; i++) {
            var $li = $('<li/>');
            var item = me.items[i];
            $li.append($('<a href="' + item.Url + '">' + item.Name + '</a><a href="#" class="favourite-remove" data-favourite-id="' + item.Id + '"><span title="Удалить" class="glyphicon glyphicon-remove" aria-hidden="true"></span></a>'));
            $ul.append($li);
          }
          me.options.$list.empty();
          if ($ul !== null) {
            me.options.$list.append($ul);
          }
          //навешиваем обработчик удаления
          $ul.find('a.favourite-remove').on('click', function (e) {
            e.preventDefault();
            me["delete"](e);
          });
        } else {
          me.options.$list.empty();
          me.options.$el.addClass('emptydata');
          me.addNoDataMessage();
        }
      }
    };
  };

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  instance.update(true);
  $(document).ready(function () {
    instance.init();
    instance.refresh();
  });
})(jQuery);